import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import Footer from '../_page_components/Footer';

const Settings = () => {
  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '100%' } }}>
      {/* cards */}
      <Grid
        container
        spacing={2}
        sx={[
          { mb: (theme) => theme.spacing(8) },
          { mt: (theme) => theme.spacing(2) },
        ]}
      >
        <Grid size={{ xs: 12, sm: 6 }}>
          <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
            Technical Direction Letters
          </Typography>
          <Box
            sx={{
              height: 800,
              width: 950,
              backgroundColor: 'grey.100',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="body1" color="textSecondary">
              No content available
            </Typography>
          </Box>
        </Grid>
        <Grid>
          <Stack
            gap={2}
            direction={{ xs: 'column', sm: 'column', lg: 'column' }}
          >
            <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
              Financial Outlook
            </Typography>
            <Box sx={{ width: '100%' }}>
              <Skeleton variant="rectangular" height={100} />
            </Box>
          </Stack>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        sx={[
          { mb: (theme) => theme.spacing(4) },
          { mt: (theme) => theme.spacing(2) },
        ]}
      >
        <Grid size={{ xs: 12, sm: 6 }}>
          {/* Placeholder for additional content */}
          <Skeleton variant="rectangular" height={200} />
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mb: (theme) => theme.spacing(2) }}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
            SLA's
          </Typography>
          <Skeleton variant="rectangular" height={150} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
            Financial Outlook
          </Typography>
          <Skeleton variant="rectangular" height={150} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
            Issues, Risk, and Opportunities
          </Typography>
          <Skeleton variant="rectangular" height={150} />
        </Grid>
      </Grid>
      <Footer />
    </Box>
  );
};

export default Settings;
